import React from 'react'
import { AvatarSizeEnum } from './Avatar'

export const LetterAvatar:React.FunctionComponent<{letter: string, size?: AvatarSizeEnum}> = ({letter, size}) => {
  return (
    <div className={`avatar avatar-${letter.toLowerCase()} avatar-${size}`}>{letter.toUpperCase()}</div>
  )
}

